<template>
  <div v-loading="isLoading">
    <el-table
      :data="noautobooks"
      stripe
    >
      <el-table-column
        label="Account"
        prop="team"
        :formatter="(row, col, cellValue) => cellValue.account ? cellValue.account.name : '-'"
      />
      <el-table-column
        label="Team"
        prop="team"
        :formatter="(row, col, cellValue) => cellValue.name || '-'"
      />
      <el-table-column
        label="Carrier"
        prop="carrier_service"
        :formatter="(row, col, cellValue) => cellValue.carrier ? cellValue.carrier.name : '-'"
      />
      <el-table-column
        label="Carrier Service"
        prop="carrier_service"
        :formatter="(row, col, cellValue) => cellValue.name || '-'"
      />
      <el-table-column
        v-if="canDelete"
        label="Actions"
        align="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="canDelete"
            size="mini"
            type="danger"
            @click.native="deleteNoAutobook(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>
    <!-- EDIT FORM -->
    <TeamBlockedAutoBookEditForm
      ref="editForm"
      :account-id="accountId"
      :team-id="teamId"
      @saved="loadTable"
    />
  </div>
</template>

<script>
import TeamBlockedAutoBookEditForm from '@/components/Application/Manage/Account/TeamBlockedAutoBookEditForm'
import { CREATE, DELETE } from '@/plugins/user'
export default {
  components: {
    TeamBlockedAutoBookEditForm
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    teamId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      noautobooks: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: false
    }
  },
  computed: {
    canDelete () {
      return this.$user.can(DELETE, 'account_team')
    }
  },
  created () {
    this.loadTable()
  },
  mounted () {
    this.actions = [
      {
        hidden: this.$user.cannot(CREATE, 'account_team'),
        name: 'Create',
        icon: ['fal', 'plus'],
        event: () => {
          this.$refs.editForm.noautobook = {}
          this.$refs.editForm.isShow = true
        }
      },
      {
        name: 'Refresh',
        icon: ['fal', 'sync'],
        event: () => this.loadTable()
      }
    ]
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.noautobook.list(builder => {
        builder.context = { resource: 'pivot' }
        builder.page = this.page
        builder.limit = this.perPage
        builder.include = ['team.account', 'carrier_service.carrier']
        builder.filters = { pivot_no_autobook_team: [this.teamId] }
        builder.order = 'created_at:desc'
      }).then(res => {
        this.noautobooks = res
        this.total = res.total
      })
        .finally(() => {
          this.isLoading = false
        })
    },
    deleteNoAutobook (index, row) {
      this.$confirm('Are you sure to delete this no autobook?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete(builder => {
          builder.context = { resource: 'pivot' }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
